var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_8238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.625,
    y: 2.125,
    width: 38.75,
    height: 38.75,
    rx: 19.375,
    stroke: "#B8BCF9",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_8238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.499 33H15.499C14.3945 33 13.499 32.1045 13.499 31V12C13.499 10.8955 14.3945 10 15.499 10H24.9855C24.9865 10 24.988 10 24.989 10H24.999C25.159 10 25.2955 10.0805 25.387 10.1975L30.3015 15.112C30.419 15.2035 30.499 15.34 30.499 15.5V15.5105C30.499 15.5115 30.499 15.512 30.499 15.513V31C30.499 32.1045 29.6035 33 28.499 33ZM25.499 11.6905V15H28.8085L25.499 11.6905ZM29.499 16H24.999C24.7225 16 24.499 15.776 24.499 15.5V11H15.499C14.947 11 14.499 11.448 14.499 12V31C14.499 31.552 14.947 32 15.499 32H28.499C29.051 32 29.499 31.552 29.499 31V16ZM26.499 29H17.499C17.2225 29 16.999 28.7765 16.999 28.5C16.999 28.224 17.2225 28 17.499 28H26.499C26.7755 28 26.999 28.224 26.999 28.5C26.999 28.7765 26.7755 29 26.499 29ZM26.499 25H17.499C17.2225 25 16.999 24.7765 16.999 24.5C16.999 24.224 17.2225 24 17.499 24H26.499C26.7755 24 26.999 24.224 26.999 24.5C26.999 24.7765 26.7755 25 26.499 25ZM26.499 21H17.499C17.2225 21 16.999 20.7765 16.999 20.5C16.999 20.224 17.2225 20 17.499 20H26.499C26.7755 20 26.999 20.224 26.999 20.5C26.999 20.7765 26.7755 21 26.499 21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_8238",
    x: 0,
    y: 0.5,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_8238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_8238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_8238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificate-icon.a949bb70c12efcb9a3d53968852a8fdf.svg";
export { ForwardRef as ReactComponent };